import TokenRefreshResponse from "../types/TokenRefreshResponse";
import Repository from "./Repository";

const resource = "/sso";

export default {
  refreshToken() {
    return Repository.get<TokenRefreshResponse>(`${resource}/token/refresh`);
  },
  check(email: string) {
    return Repository.get<TokenRefreshResponse>(
      `${resource}/check?email=${email?.trim()}`
    );
  },
};
